import React from "react";
import {
  HiXCircle,
  // HiOutlineSun,
  // HiOutlineTrash,
  // HiOutlineArrowsExpand,
  // HiLightBulb,
  //   HiPencilAlt,
  HiOutlineX,
} from "react-icons/hi";
import { useTranslation } from "react-i18next";
export default function ExitButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button`}
        onClick={props.onClickHandler}
        title={t("Exit")}
      >
        <span className="has-text-danger ">Exit</span>
        <span className="icon  has-text-danger">
          <HiOutlineX className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
